var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"faq"},[_c('h3',{staticClass:"question"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.alt}}),_c('i',{domProps:{"innerHTML":_vm._s(_vm.question)}})]),_c('div',{staticClass:"answer"},[_c('p',[_vm._v(" "+_vm._s(_vm.answer)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }